import React from "react";
import { useHistory } from "react-router-dom";
import { StandardTooltip } from "../../../../shared/StandardTooltip/StandardTooltip";
import { ArrowRightIcon } from "../../../AnnualOkr/AnnualOkrHelpers";
import { RUN_STATE_LABEL } from "../../_config/quarterlyOkrConfig";
import {
  dashboardCtaFor,
  dashboardRouteFor,
} from "../../_config/quarterlyOkrRoutes";
import QuarterFlags from "../QuarterFlags/QuarterFlags";
import "./_quarter-row.scss";

// One other quarter in a client's accordion (next or earlier): its period,
// where its run is (or the stage a not-completed run stopped at), its flags,
// and its own button — the same `aok-view-btn` as the card's row, compact.
// A quarter with nowhere to go yet keeps a disabled button with the reason,
// so every row lines up.
const QuarterRow = ({ quarter }) => {
  const history = useHistory();
  const route = dashboardRouteFor(quarter);
  const stoppedAt =
    quarter.not_completed && quarter.stopped_at
      ? ` · stopped at ${RUN_STATE_LABEL[quarter.stopped_at] || quarter.stopped_at}`
      : "";
  const status = quarter.run_state
    ? RUN_STATE_LABEL[quarter.run_state] || quarter.run_state
    : "Not planned yet";

  const button = (
    <button
      type="button"
      className="aok-view-btn qokr-quarter-row__btn"
      disabled={!route}
      onClick={() => route && history.push(route)}
    >
      {dashboardCtaFor(quarter)}
      <ArrowRightIcon />
    </button>
  );

  return (
    <li className="qokr-quarter-row">
      <div className="qokr-quarter-row__main">
        <span className="qokr-quarter-row__label">{quarter.label}</span>
        <span className="qokr-quarter-row__dot" aria-hidden="true" />
        <span className="qokr-quarter-row__status">
          {status}
          {stoppedAt}
        </span>
        <QuarterFlags quarter={quarter} />
      </div>
      {route ? (
        button
      ) : (
        <StandardTooltip
          tooltTipContent={
            quarter.run_unique_id
              ? "The CEO hasn't sent this quarter's OKRs to you yet."
              : "The CEO hasn't started planning this quarter yet."
          }
        >
          <span className="aok-view-btn-wrap">{button}</span>
        </StandardTooltip>
      )}
    </li>
  );
};

export default QuarterRow;
